import './src/styles/global.css'
import { handleDarkModeWithLocalStorageAndUserPreference } from './src/lib/user-preference-dark-mode'

export const onClientEntry = () => {
  handleDarkModeWithLocalStorageAndUserPreference()
}
